module.exports = "https://cdn.hellotech.com/client-assets/home-front-desktop_d44101c5eac38e5ee163fdf028796ed3.webp";